import { createMiddleware } from "@tanstack/react-start";
import { publishedSiteBuildHeader } from "../../../shared/src/published-site";

declare const __DRATE_SITE_BUILD__: string | undefined;
const build = typeof __DRATE_SITE_BUILD__ === "string" ? __DRATE_SITE_BUILD__ : "development";

/** Old documents retain their assets; public data must still match that document's build. */
export const publicationBuild = createMiddleware({ type: "function" }).client(async ({ next }) =>
  next({
    headers: { [publishedSiteBuildHeader]: build },
    fetch: async (url, init) => {
      const response = await fetch(url, init);
      if (
        response.status === 409 &&
        response.headers.get("X-Drate-Published-Site") === "build-reload"
      ) {
        window.location.reload();
        throw new Error("The website was updated. Reloading.");
      }
      return response;
    },
  }),
);
